// extracted by mini-css-extract-plugin
export default {"contentText":"Content_contentText__PL1hS","mainDiv":"Content_mainDiv__ijSF5","HeadingTitle":"Content_HeadingTitle__kShEY","actionBar":"Content_actionBar__qHyaj"};